import { render, staticRenderFns } from "./FilterAge.vue?vue&type=template&id=5ab77ec3&"
import script from "./FilterAge.controller.js?vue&type=script&lang=js&"
export * from "./FilterAge.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./FilterAge.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "caf89fec"
  
)

export default component.exports